import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import {MatPaginator as MatPaginator } from '@angular/material/paginator';
import { data } from 'jquery';
import { UserApiService } from '../../user-api.service';
import { LoginType } from 'src/app/shared/enums/enums';

@Component({
  selector: 'app-login-info',
  templateUrl: './login-info.component.html',
  styleUrls: ['./login-info.component.css']
})
export class LoginInfoComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  ElogginType = LoginType;
  listOfLoggedType: any[] = [];


  displayedColumns: string[] = ['loginDate', 'hostName', 'loggingType']
  dataSource: any;
  filter = {
    pageNumber: 0,
    pageSize: 10,
    userId: 0
  }
  totalRecord = 0
  constructor(
    private dialogRef: MatDialogRef<LoginInfoComponent>,
    private userService: UserApiService,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.filter.userId = data.userId
  }

  ngOnInit() {
    if (this.filter.userId) {
      this.getInfo()
    }

  }
  getInfo() {
    
    this.userService.getUserLoginTransactions(this.filter).subscribe((res: any) => {
      this.dataSource = res.data;
      this.totalRecord = res.totalCount;
    })
  }
  close() {
    this.dialogRef.close();
  }
  changePage(event) {
    this.filter.pageSize = event.pageSize;
    this.filter.pageNumber = event.pageIndex;
    this.getInfo();
  }

  loggedTypeMethod(data) {
    for (const key in LoginType) {
      if (data == LoginType[key]) {
        return data = key.replace("_","   ")
      }
    }
  }
}
